import React from 'react';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';
import Reward from './reward';

const { Order } = Mobi2Go;

export default forwardRefWithTranslation('customer.rewards')(
    class RewardsModal extends React.Component {
        state = {
            rewards: [],
            reward_applied_to_order: null,
        };

        componentDidMount = () => {
            Order.bind({
                updateAvailableRewards: this.updateRewards,
                updateReward: this.updateRewardAppliedToOrder,
            });
            this.updateRewards();
            this.updateRewardAppliedToOrder();
        };

        updateRewards = () => {
            this.setState({
                rewards: Order.getAvailableRewards(),
            });
        };

        updateRewardAppliedToOrder = () => {
            this.setState({
                reward_applied_to_order: Order.getReward(),
            });
        };

        onRewardUseClick = reward => {
            Order.log('click use reward', {
                reward: {
                    id: reward.id,
                    title: reward.title,
                },
            });
            Order.setReward(reward);
            this.props.closeModal();
        };

        render() {
            const available_rewards = this.state.rewards.length;

            if (!available_rewards) {
                return null;
            }

            const { t } = this.props;
            const header_text = t('header', {
                count: this.state.rewards.length,
                reward_label: t('label'),
            });
            return (
                <div>
                    <ModalHeader
                        onClose={this.props.closeModal}
                        headerText={header_text}
                    />
                    <div className="m2g-modal-body m2g-customer-rewards-modal-body">
                        <div className="m2g-customer-rewards-modal-list">
                            {_.map(this.state.rewards, reward => (
                                <Reward
                                    {...reward}
                                    key={reward.id}
                                    onUseClick={() => {
                                        this.onRewardUseClick(reward);
                                    }}
                                    is_applied_to_order={
                                        this.state.reward_applied_to_order &&
                                        this.state.reward_applied_to_order
                                            .id === reward.id
                                    }
                                />
                            ))}
                        </div>
                    </div>
                </div>
            );
        }
    }
);
